import script from "./MobileNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileNavBar.vue?vue&type=script&setup=true&lang=js"

import "./MobileNavBar.vue?vue&type=style&index=0&id=4455d5d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4455d5d9"]])

export default __exports__